module.exports = __webpack_public_path__ + "img/temp-banner-insights.6479a6ae.jpg";